<template>
<div class="mdc-notched-outline"
    :class="{'mdc-notched-outline--notched': preFilled}"
>
  <div class="mdc-notched-outline__leading" />
  <div class="mdc-notched-outline__notch">
    <label class="mdc-floating-label"  :class="{'mdc-floating-label--float-above': preFilled}" :for="id">{{ label}}</label>
  </div>
  <div class="mdc-notched-outline__trailing" />
</div>
</template>

<script>
export default {
  name: "bk-outline-notched",
  props: {
    /**
     * Id of the notched outline
     */
    id: {
      type: String,
      default: ''
    },
    /**
     * Label of the notched outline
     */
    label: {
      type: String,
      required: true
    },

    preFilled: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped lang="scss">
  //@import "../scss/colors";
  //@import "~@material/notched-outline/mdc-notched-outline";
  //
  //.mdc-text-field--valid > .mdc-notched-outline > * {
  //  border-color: $feedback !important;
  //}
  //
  //.mdc-select--valid > .mdc-notched-outline > * {
  //  border-color: $feedback !important;
  //}
  //
  //.mdc-text-field--invalid > .mdc-notched-outline > *,
  //.invalid > .mdc-notched-outline > * {
  //  border-color: $error !important;
  //}
  //
  //.invalid > .mdc-notched-outline > .mdc-notched-outline__notch > * {
  //  color: $error;
  //}



</style>
